module.exports = __webpack_public_path__ + "static/atlantique-hero.781205f6.jpg";